<template>
  <section class="w-full lg:container lg:mx-auto" ref="showList">
    <PerformanceList :performances="selectedPerformance" :idsToForcePurchase="[performanceId]" />
  </section>
</template>

<script lang="ts" setup>
import { computed, onMounted, onServerPrefetch, toRefs } from 'vue'
import { useRoute } from 'vue-router'

import { StorePerformance } from '@/models'
import PerformanceList from '@/modules/guestUi/components/organisms/PerformanceList.vue'
import { usePerformancePaginate } from '@/modules/guestUi/stores/PerformancePaginateStore'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'

const props = withDefaults(defineProps<{ performanceId?: number }>(), {
  performanceId: undefined,
})
const { performanceId } = toRefs(props)

const checkoutStore = useCheckoutStore()
const performancePaginateStore = usePerformancePaginate()
const settingStore = useSettingStore()
const route = useRoute()
const inviteCode = computed<string | undefined>(() => route.query.invite as string | undefined)

onMounted(async () => {
  await checkoutStore.abandonAndClear()
  checkoutStore.setInviteCode(inviteCode.value)
})

onServerPrefetch(fetchPerformance)
async function fetchPerformance() {
  try {
    if (!performanceId.value) {
      settingStore.ssrTitle = settingStore.venue_name
      settingStore.notFound = true
      return
    }
    try {
      await performancePaginateStore.getIndividualPerformance(performanceId.value, inviteCode.value)
    } catch {
      // Performance fetch failed (e.g. 404) — handled below via missing performance.
    }
    const performance = performancePaginateStore.detailPerformances.find(
      p => p.id === performanceId.value,
    )
    if (performance) {
      settingStore.ssrTitle = `${performance.show.name} - ${settingStore.venue_name}`
    } else {
      settingStore.ssrTitle = settingStore.venue_name
      settingStore.notFound = true
    }
  } finally {
    settingStore.ssrPrefetchDone = true
  }
}

const selectedPerformance = computed<StorePerformance[]>(() => {
  const performance = performancePaginateStore.detailPerformances.find(
    performance => performance.id === performanceId.value,
  )
  return performance ? [performance] : []
})

defineExpose({ fetchPerformance })
</script>
